var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedVegetables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000488281,
    width: 40.0004,
    height: 40.0004,
    rx: 20.0002,
    fill: "#CCF5F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7222 21.3347C23.0492 23.0067 11.298 32.0449 9.62601 30.3738C7.95398 28.7008 16.9921 16.9496 18.6651 15.2776C20.3372 13.6046 23.0492 13.6056 24.7222 15.2776C26.3943 16.9506 26.3943 19.6627 24.7222 21.3347Z",
    stroke: "#00837B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.205 14.2605H27.68L29.42 12.5195C29.955 11.9855 29.955 11.1155 29.42 10.5815C29.161 10.3205 28.816 10.1785 28.45 10.1785C28.084 10.1785 27.739 10.3214 27.48 10.5804L25.74 12.3205V10.7955C25.74 10.0395 25.125 9.42346 24.367 9.42346C23.611 9.42346 22.996 10.0395 22.996 10.7955V14.2465C23.626 14.4475 24.223 14.7795 24.723 15.2785C25.222 15.7785 25.553 16.3745 25.754 17.0045H29.205C29.961 17.0045 30.577 16.3894 30.577 15.6324C30.577 14.8754 29.96 14.2605 29.205 14.2605Z",
    stroke: "#00837B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.689 20.9365C18.689 20.9365 19.32 21.7755 20.463 22.2315",
    stroke: "#00837B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4271 25.2157C16.8501 25.7077 17.5641 26.1117 18.2051 26.4037",
    stroke: "#00837B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8271 24.4508C12.1311 24.9918 12.623 25.6628 13.326 26.0078",
    stroke: "#00837B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.902 19.9766C15.238 20.5446 15.765 21.2616 16.427 21.5846",
    stroke: "#00837B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.208 15.7755C18.645 16.7095 19.354 17.7585 20.447 18.5135",
    stroke: "#00837B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedVegetables);
export default __webpack_public_path__ + "static/media/rounded-vegetables.dd96b1c3818c1c5f880c83a8a4129a12.svg";
export { ForwardRef as ReactComponent };